import { Checkbox, DataSource, Label, Layout, Panel, Switch, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCheckCallComplianceDetail extends Layout {
    checkboxExcludeOrderType: Checkbox;
    checkboxIncldBrokerinitiatedCalls: Checkbox;
    checkboxIncldCarrInitiatedCalls: Checkbox;
    labelAdded: Label;
    labelComplianceDetail3: Label;
    labelComplianceDetail4: Label;
    labelComplianceDetail: Label;
    labelDividend: Label;
    labelDivisor: Label;
    labelI: Label;
    labelLeftParen: Label;
    labelRightParen: Label;
    labelSubtracted: Label;
    labelWeight: Label;
    panelFormula: Panel;
    sourceCarrierScorecardDetail: DataSource;
    switchCountCarriercallsOntime: Switch;
    tabScoringDetails: Tab;
    tabsetScoringDetails: Tabset;
    textboxEndOfPeriod: Textbox;
    textboxGracePeriod: Textbox;
    textboxMinimumRecords: Textbox;
    textboxOrderTypes: Textbox;
    textboxStartOfPeriod: Textbox;
    textboxWeight: Textbox;
}
